import { BackIcon, FinishedIcon } from "@/components/RFIcon";
import Image from "next/image";
interface Props {
	done: boolean;
	title: string;
	desc: string;
	iconDark: string;
	iconLight: string;
	btnText: string;
	onClick?: () => void;
}
export default function TaskCard(props: Props) {
	return (
		<div
			className="flex items-center py-4 pl-3.5 pr-5 rounded-xl dark:bg-black_15 bg-purple_F7F6FF last:mb-0 mb-2.5"
			onClick={() => {
				if (props.done) return;
				props.onClick?.();
			}}
		>
			<div className="flex-1 flex items-center mr-3">
				<div className="w-14 h-14 relative flex-shrink-0">
					<Image
						src={props.iconLight}
						width={56}
						height={56}
						className="w-full h-full object-contain inline-block dark:hidden"
						alt="icon"
						priority
					/>
					<Image
						src={props.iconDark}
						width={56}
						height={56}
						className="w-full h-full object-contain hidden dark:inline-block"
						alt="icon"
						priority
					/>
				</div>
				<div className="flex-1 ml-5">
					<div className="text-sm font-semibold link-text">{props.title}</div>
					<p className="text-xs dark:text-gray_79 text-dark font-normal mt-0.5">{props.desc}</p>
				</div>
			</div>

			<div className="flex-shrink-0">
				{props.done ? (
					<FinishedIcon className="w-4 h-4 dark:text-gray_54 text-gray_ce" strokeWidth={2.5} />
				) : (
					<a className="block" style={{ transform: "rotate(180deg)" }}>
						<BackIcon className="w-4 h-4 link-text" strokeWidth={2.5} />
					</a>
				)}
			</div>
		</div>
	);
}
